import { createContext } from 'react';
var defaultValue = {
    environmentName: 'page',
};
export var EnvironmentContext = createContext(defaultValue);
